// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"a834de23","728":"421b0369","819":"e671a8fc","833":"2393bcd5","935":"d7c6eb5d"}[chunkId] + ".chunk.js";
};